import { memo, useCallback, useEffect, useState } from 'react';
import CardIcon from '../../../images/icon-card.svg';
import InfinityIcon from '../../../images/icon-infinity.svg';
import TruckIcon from '../../../images/icon-truck.svg';
import HandCoinIcon from '../../../images/icon-hand.svg';
import { getSubscriptionSavedMoney } from '../../../utils/service';
import { formatCurrencyNumber } from '../../../utils/numbers';
import LoadingBar from '../../../global/LoadingBar';

import './MembershipPerks.scss';

const perks = [
  {
    id: 'unlimited-recycling',
    icon: InfinityIcon,
    text: 'Unlimited Clean Outs',
  },
  {
    id: 'free-pickup',
    icon: TruckIcon,
    text: 'Free Shipping',
  },
  {
    id: 'earn-rewards',
    icon: CardIcon,
    text: 'Earn more, Faster',
  },
];

const MembershipPerks = ({
  title,
  refetchSavedMoney = false,
}) => {
  const [savedMoney, setSavedMoney] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSavedMoney = useCallback(async () => {
    setIsLoading(true);
    const { data, error } = await getSubscriptionSavedMoney();
    if (error) {
      setIsLoading(false);
      return;
    }
    setSavedMoney(data?.totalSavedAmount || 0);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (refetchSavedMoney) {
      fetchSavedMoney();
    }
  }, [refetchSavedMoney]);

  useEffect(() => {
    fetchSavedMoney();
  }, []);

  return (
    <div className="MembershipPerks">
      {isLoading ? <LoadingBar /> : (
        <div className="MembershipPerks__container">
          {title && (
          <div className="MembershipPerks__container--header">
            <div className="MembershipPerks__container--header-title">
              {title}
            </div>
          </div>
          )}
          <div className="MembershipPerks__container--content">
            <div className="MembershipPerks__container--content-items">
              {perks.map((perk) => (
                <div
                  className="MembershipPerks__container--content-items-item"
                  key={perk.id}
                >
                  <div className="MembershipPerks__container--content-items-item-icon">
                    <img
                      src={perk.icon}
                      alt="check icon"
                      width="20"
                      height="20"
                    />
                  </div>
                  <div className="MembershipPerks__container--content-items-item-text">
                    {perk.text}
                  </div>
                </div>
              ))}
            </div>
            <div className="MembershipPerks__container--content-savedMoney">
              <div className="MembershipPerks__container--content-savedMoney-icon">
                <img
                  src={HandCoinIcon}
                  alt="hand coin icon"
                  width="24"
                  height="24"
                />
              </div>
              <div className="MembershipPerks__container--content-savedMoney-text">
                <div className="MembershipPerks__container--content-savedMoney-text-amount">
                  <span className="MembershipPerks__container--content-savedMoney-text-amount-bold">
                    {`You’ve saved ${formatCurrencyNumber(savedMoney)}`}
                  </span>
                  <span className="MembershipPerks__container--content-savedMoney-text-amount-regular">
                    {' '}
                    with Trashie Unlimited so far
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(MembershipPerks);
